import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "@services/app.service";
import { Subject, takeUntil } from "rxjs";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { NewJoinForms } from "@/model/new-joining-form/new_JoinForms";
import Swal from "sweetalert2";
import { AssetDetails } from "@/model/new-joining-form/asset-details";
import { DesignationDetails } from "@/model/designation-details";
import { ConfigService } from "@/config.service";

@Component({
  selector: "app-new-joining-forms",
  templateUrl: "./new-joining-forms.component.html",
  styleUrls: ["./new-joining-forms.component.scss"],
  providers: [DatePipe],
})
export class NewJoiningFormsComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  getFormId: any = "";
  currentNewJoinId: any = "";
  trainneDisable = false;
  stipendDisable = false;
  bankDisable = true;
  newJoiningDetails: NewJoinForms | undefined;
  currentNewJoinDetails: NewJoinForms;
  age: string = "";
  birthdate: Date | null = null;
  nextButton = false;
  saveButton = true;
  currentDate: string | null = null;
  formId: number = 0;
  isUpdate: boolean = false;
  userType: string = "";
  onShowRelivingDate: boolean = false;
  imageList: AssetDetails[] = [];
  designationDetails: DesignationDetails[] = [];
  endPoint: String = "";
  bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
  isLoginUserDetails: boolean = false;
  employeeStatusList = [
    { value: 0, label: "WORKING" },
    { value: 1, label: "RELIEVED" },
  ];
  bankNames: string[] = [
    "State Bank of India",
    "HDFC Bank",
    "ICICI Bank",
    "Punjab National Bank",
    "Bank of Baroda",
    "Canara Bank",
    "Axis Bank",
    "Kotak Mahindra Bank",
    "IndusInd Bank",
    "Yes Bank",
    "Union Bank of India",
    "IDBI Bank",
    "Bank of India",
    "Indian Bank",
    "Central Bank of India",
    "Indian Overseas Bank",
    "Bank of Maharashtra",
    "UCO Bank",
    "Punjab & Sind Bank",
    "Federal Bank",
    "South Indian Bank",
    "RBL Bank",
    "Karur Vysya Bank",
    "City Union Bank",
    "Tamilnad Mercantile Bank",
    "Dhanlaxmi Bank",
    "Jammu & Kashmir Bank",
    "Karnataka Bank",
    "Andhra Bank",
    "Allahabad Bank",
    "Corporation Bank",
    "Oriental Bank of Commerce",
    "Syndicate Bank",
    "Vijaya Bank",
    "Dena Bank",
    "Bharatiya Mahila Bank",
    "IDFC First Bank",
    "Bandhan Bank",
    "Equitas Small Finance Bank",
    "Ujjivan Small Finance Bank",
    "AU Small Finance Bank",
    "ESAF Small Finance Bank",
    "Fincare Small Finance Bank",
    "Jana Small Finance Bank",
    "North East Small Finance Bank",
    "Shivalik Small Finance Bank",
    "Suryoday Small Finance Bank",
    "Utkarsh Small Finance Bank",
    "Paytm Payments Bank",
    "Airtel Payments Bank",
    "India Post Payments Bank",
    "Fino Payments Bank",
    "Jio Payments Bank",
  ].sort((a, b) => a.localeCompare(b));

  documentTypes = [
    {
      id: "aadharUpload",
      type: "AADHARCARD",
      label: "Aadhar Card File Upload",
    },
    { id: "panUpload", type: "PANCARD", label: "Pan Card File Upload" },
    {
      id: "bankUpload",
      type: "BANKPASSBOOK",
      label: "Bank Passbook File Upload",
    },
    { id: "profile", type: "PROFILE", label: "Profile File Upload" },
  ];

  constructor(
    private router: Router,
    private appService: AppService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private activatedRoute: ActivatedRoute,
    private configService: ConfigService
  ) {
    this.currentDate =
      this.datePipe.transform(new Date(), "yyyy-MM-dd") || null;
  }
  Newjoin = new UntypedFormGroup({
    formId: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    employeeType: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    location: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    newJoinId: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    employeeJoiningDate: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    employeeName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    employeeFatherName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    gender: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    dateOfBirth: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    age: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    designation: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    qualification: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    address: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    employeeLocation: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    bloodGroup: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    aadharNo: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
      Validators.pattern("^((\\+91-?)|0)?[0-9]{12}$"),
    ]),
    bankName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    branchName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    bankIfscCode: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    nameAsInPassbook: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    accountNo: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    employeeContactNo: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
      Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),
    ]),
    emergencyContactNo: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
      Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),
    ]),
    salaryValueFixed: new UntypedFormControl("", [
      Validators.required,
      Validators.min(0),
    ]),
    allowedLeaveDays: new UntypedFormControl(0, [
      Validators.required,
      Validators.min(0),
    ]),
    workingStatus: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    relieveDate: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    minimumLeavePolicy: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    otherAllowance: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    salaryType: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    userName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    password: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    assetDetails: new UntypedFormControl(
      [],
      [Validators.required, Validators.nullValidator]
    ),
  });
  public NewJoinErrors = {
    location: "",
    employeeType: "",
    employeeJoiningDate: "",
    employeeName: "",
    employeeFatherName: "",
    gender: "",
    dateOfBirth: "",
    age: "",
    designation: "",
    qualification: "",
    address: "",
    employeeLocation: "",
    bloodGroup: "",
    aadharNo: "",
    bankName: "",
    branchName: "",
    bankIfscCode: "",
    nameAsInPassbook: "",
    accountNo: "",
    employeeContactNo: "",
    emergencyContactNo: "",
    salaryValueFixed: "",
    allowedLeaveDays: "",
    workingStatus: "",
    relieveDate: "",
    minimumLeavePolicy: "",
    salaryType: "",
    userName: "",
    password: "",
  };

  ngOnInit() {
    this.userType = localStorage.getItem("userType");
    const encodedId = localStorage.getItem("formId");
    this.formId = +atob(encodedId) || 0;
    if (this.formId == 0) {
      this.getJoinID();
      this.Newjoin.controls["workingStatus"].setValue("WORKING");
      this.onShowRelivingDate = false;
    } else {
      this.endPoint = this.configService.getConfig().END_POINT;
      this.getByIdBasedNewJoiningDetails(this.formId);
    }
    this.getAllDesignationDetails();
  }

  onSubmit() {
    this.formValidation();
  }

  formValidation() {
    const empContact = this.Newjoin.get("employeeContactNo");
    const emerContact = this.Newjoin.get("emergencyContactNo");
    this.NewJoinErrors.location = "";
    this.NewJoinErrors.employeeType = " ";
    this.NewJoinErrors.employeeJoiningDate = "";
    this.NewJoinErrors.employeeName = "";
    this.NewJoinErrors.employeeFatherName = "";
    this.NewJoinErrors.gender = "";
    (this.NewJoinErrors.dateOfBirth = ""), (this.NewJoinErrors.age = "");
    this.NewJoinErrors.designation = "";
    this.NewJoinErrors.qualification = "";
    this.NewJoinErrors.address = "";
    this.NewJoinErrors.employeeLocation = "";
    this.NewJoinErrors.bloodGroup = "";
    this.NewJoinErrors.aadharNo = "";
    this.NewJoinErrors.bankName = "";
    this.NewJoinErrors.branchName = "";
    this.NewJoinErrors.bankIfscCode = "";
    this.NewJoinErrors.nameAsInPassbook = "";
    this.NewJoinErrors.accountNo = "";
    this.NewJoinErrors.employeeContactNo = "";
    this.NewJoinErrors.emergencyContactNo = "";
    this.NewJoinErrors.salaryValueFixed = "";
    this.NewJoinErrors.allowedLeaveDays = "";
    this.NewJoinErrors.workingStatus = "";
    this.NewJoinErrors.relieveDate = "";
    this.NewJoinErrors.minimumLeavePolicy = "";
    this.NewJoinErrors.salaryType = "";
    let hasError = false;
    console.log(this.NewJoinErrors);
    if (this.Newjoin.get("employeeType")?.invalid) {
      this.NewJoinErrors.employeeType = "*Employee type is required";
      hasError = true;
    }
    if (this.Newjoin.get("location")?.invalid) {
      this.NewJoinErrors.location = "*location is required";
      hasError = true;
    }
    if (this.Newjoin.get("employeeJoiningDate")?.invalid) {
      this.NewJoinErrors.employeeJoiningDate =
        "*Employee joining date is required";
      hasError = true;
    }
    if (this.Newjoin.get("employeeName")?.invalid) {
      this.NewJoinErrors.employeeName = "*Employee name is required";
      hasError = true;
    }
    if (this.Newjoin.get("employeeFatherName")?.invalid) {
      this.NewJoinErrors.employeeFatherName =
        "*Employee Father's name is required";
      hasError = true;
    }

    if (this.Newjoin.get("gender")?.invalid) {
      this.NewJoinErrors.gender = "*Gender is required";
      hasError = true;
    }

    if (this.Newjoin.get("dateOfBirth")?.invalid) {
      this.NewJoinErrors.dateOfBirth = "*Date of birth is required";
      hasError = true;
    }

    if (this.Newjoin.get("age")?.invalid) {
      this.NewJoinErrors.age = "*Age is required";
      hasError = true;
    }

    if (this.Newjoin.get("designation")?.invalid) {
      this.NewJoinErrors.designation = "*Designation is required";
      hasError = true;
    }

    if (this.Newjoin.get("qualification")?.invalid) {
      this.NewJoinErrors.qualification = "*Qualification is required";
      hasError = true;
    }

    if (this.Newjoin.get("address")?.invalid) {
      this.NewJoinErrors.address = "*Address is required";
      hasError = true;
    }

    if (this.Newjoin.get("employeeLocation")?.invalid) {
      this.NewJoinErrors.employeeLocation = "*Employee location is required";
      hasError = true;
    }

    if (this.isLoginUserDetails) {
      if (this.Newjoin.get("userName")?.invalid) {
        this.NewJoinErrors.userName = "*Username is required";
        hasError = true;
      }

      if(!this.isUpdate){
      if (this.Newjoin.get("password")?.invalid) {
        this.NewJoinErrors.password = "*Password is required";
        hasError = true;
      }
    }
    }

    if (this.Newjoin.get("bloodGroup")?.invalid) {
      this.NewJoinErrors.bloodGroup = "*Blood group is required";
      hasError = true;
    }

    if (
      this.Newjoin.get("employeeType")?.value !== "Trainee" ||
      this.Newjoin.get("stipend")?.value == "Yes"
    ) {
      if (this.Newjoin.get("aadharNo")?.invalid) {
        if (this.Newjoin.get("aadharNo")?.errors?.["required"]) {
          this.NewJoinErrors.aadharNo = "*Aadhar number is required";
        }
        if (this.Newjoin.get("aadharNo")?.getError("pattern")) {
          this.NewJoinErrors.aadharNo = "*Enter a 12-digit Aadhar number.";
        }
        hasError = true;
      }
      if (this.Newjoin.get("bankName")?.invalid) {
        this.NewJoinErrors.bankName = "*Bank name is required";
        hasError = true;
      }
      if (this.Newjoin.get("branchName")?.invalid) {
        this.NewJoinErrors.branchName = "*Branch name is required";
        hasError = true;
      }
      if (this.Newjoin.get("bankIfscCode")?.invalid) {
        this.NewJoinErrors.bankIfscCode = "*Bank ifsc code is required";
        hasError = true;
      }
      if (this.Newjoin.get("nameAsInPassbook")?.invalid) {
        this.NewJoinErrors.nameAsInPassbook =
          "*Name as in Passbook is required";
        hasError = true;
      }
      if (this.Newjoin.get("accountNo")?.invalid) {
        this.NewJoinErrors.accountNo = "*Account number required";
        hasError = true;
      }

      // Employee contact validation
      if (empContact?.invalid) {
        if (empContact.errors?.["required"]) {
          this.NewJoinErrors.employeeContactNo = "*Phone number is required";
        } else if (empContact.errors?.["pattern"]) {
          this.NewJoinErrors.employeeContactNo =
            "*Enter a 10-digit Phone number.";
        }
        hasError = true;
      }

      // Emergency contact validation
      if (emerContact?.invalid) {
        if (emerContact.errors?.["required"]) {
          this.NewJoinErrors.emergencyContactNo =
            "*Emergency contact no is required";
        } else if (emerContact.errors?.["pattern"]) {
          this.NewJoinErrors.emergencyContactNo =
            "*Enter a 10-digit Phone number.";
        }
        hasError = true;
      }

      // Simple check if both are valid and same
      if (
        empContact?.valid &&
        emerContact?.valid &&
        empContact.value === emerContact.value
      ) {
        const errorMsg =
          "*Employee and Emergency contact numbers cannot be the same";
        this.NewJoinErrors.employeeContactNo = errorMsg;
        this.NewJoinErrors.emergencyContactNo = errorMsg;
        hasError = true;
      }

      if (this.Newjoin.get("workingStatus")?.invalid) {
        this.NewJoinErrors.workingStatus = "*Work status is required";
        hasError = true;
      }

      const salaryType = this.Newjoin.get("salaryType")?.value;

        if (salaryType === "Fixed" || salaryType === "PerIndex") {
        if (this.Newjoin.get("minimumLeavePolicy")?.invalid) {
          this.NewJoinErrors.minimumLeavePolicy = "*Leave Policy is required";
          hasError = true;
        }

        if (this.Newjoin.get("minimumLeavePolicy").value === "Yes") {
          if (this.Newjoin.get("allowedLeaveDays")?.invalid) {
            this.NewJoinErrors.allowedLeaveDays =
              "*Allowed leave days is required";
            hasError = true;
          }
        }

        if (this.Newjoin.get("salaryValueFixed")?.invalid) {
          this.NewJoinErrors.salaryValueFixed =
            "*Salary value fixed is required";
          hasError = true;
        }
      }

      if (this.Newjoin.get("workingStatus").value != "WORKING") {
        if (this.Newjoin.get("relieveDate")?.invalid) {
          this.NewJoinErrors.relieveDate = "*Relieving date is required";
          hasError = true;
        }
      }

      if (this.Newjoin.get("salaryType")?.invalid) {
        this.NewJoinErrors.salaryType = "*Salary type is required";
        hasError = true;
      }
    }

    if (!hasError) {
      if (this.isUpdate) {
        if (this.userType == "DOCTOR") {
          this.updateNewSalaryDetails();
        } else {
          this.updateNewJoining();
        }
      } else {
        this.saveNewJoining();
      }
    }
  }

  getAllDesignationDetails() {
    this.spinner.show();
    this.appService
      .getAllDesignationDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.designationDetails = data;
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error(
            error.error.message || "Something went wrong,please try again...."
          );
        }
      );
  }

  onSelectStatus(event: any) {
    const value = event.target.value;
    if (value == "WORKING") {
      this.onShowRelivingDate = false;
    } else {
      this.onShowRelivingDate = true;
    }
  }

  onSelectDesignation(input: string | Event): void {
    let value: string;

    if (typeof input === "string") {
      // Called programmatically with a string
      value = input;
    } else {
      // Called from the DOM, extract the value
      const target = input.target as HTMLSelectElement;
      value = target.value;
    }

    console.log("Selected designation:", value);

    this.isLoginUserDetails =
      value === "Data Entry Operator" || value === "Software Developer" 
      || value === "Tech Lead" || value === 'Software Tester';
  }

  saveNewJoining() {
    this.spinner.show();
    this.Newjoin.controls["newJoinId"].setValue(this.currentNewJoinId);
    this.appService
      .saveNewJoining(this.Newjoin.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.newJoiningDetails = data;
          this.fileUploadDetails();
        },
        (err: any) => {
          console.log("something went wrong:", err);
          this.spinner.hide();
          this.errorAlert();
        },
        () => console.log("HTTP request completed.")
      );
  }

  fileUploadDetails() {
    this.imageList.forEach((item) => {
      item.referenceId = this.newJoiningDetails.formId;
    });
    this.appService
      .fileUpload(this.imageList)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.SuccessAlert();
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error(
            error.message || "Something went wrong,please try again..."
          );
        }
      );
  }

  getJoinID() {
    this.appService
      .getJoinID()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          console.log(data);
          this.getFormId = data;
          this.currentNewJoinId = data;
        },
        (error: any) => {
          this.toaster.error(
            error.message || "Something Went Wrong,Please Try Again.."
          );
        }
      );
  }

  onEmployee(event: any) {
    const value = event.target.value;
    if (value == "Trainee") {
      this.trainneDisable = true;
      this.stipendDisable = true;
      this.bankDisable = false;
    } else {
      this.trainneDisable = false;
      this.stipendDisable = false;
      this.bankDisable = true;
    }
  }

  stipend(event: any) {
    const value = event.target.value;
    if (value == "Yes") {
      this.bankDisable = true;
      localStorage.setItem("stipend", value);
    } else if (value == "No") {
      this.bankDisable = false;
      localStorage.setItem("stipend", value);
    }
  }

  dateOfBirth(event: any) {
    const value: string = event.target.value;
    this.birthdate = new Date(value);
    if (this.birthdate) {
      const timeDiff: number = Date.now() - this.birthdate.getTime();
      const ageDate: Date = new Date(timeDiff);
      //@ts-ignore
      this.age = Math.abs(
        Math.floor(ageDate.getTime() / (1000 * 60 * 60 * 24 * 365.25))
      );
      this.Newjoin.get("age")?.setValue(this.age);
    }
  }

  Navigate() {
    this.router.navigate(["/FileUpload"]);
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  fileUpload(event: any, type: string) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/bmp",
        "image/webp",
      ];

      if (!allowedTypes.includes(file.type)) {
        this.toaster.error(
          "Only PNG, JPG, JPEG, BMP, and WEBP files are allowed."
        );
        return;
      }

      const maxSizeInBytes = 2 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        this.toaster.error("File size must be below 2MB.");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          this.resizeImage(img, 600, 600, 200).then((resizedBase64) => {
            this.addImageToList(resizedBase64, file, type);
          });
        };
      };
      reader.readAsDataURL(file);
      input.value = "";
    }
  }

  // Resize & compress image
  resizeImage(
    image: HTMLImageElement,
    width: number,
    height: number,
    maxSizeInKB: number = 200
  ): Promise<string> {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;

      if (!ctx) return resolve("");

      ctx.drawImage(image, 0, 0, width, height);
      let quality = 0.9;
      let compressed = canvas.toDataURL("image/jpeg", quality);

      while (compressed.length / 1024 > maxSizeInKB && quality > 0.1) {
        quality -= 0.05;
        compressed = canvas.toDataURL("image/jpeg", quality);
      }

      console.log(
        `Compressed image size: ${((compressed.length * 3) / 4 / 1024).toFixed(2)} KB`
      );
      resolve(compressed);
    });
  }

  addImageToList(base64String: string, file: File, type: string) {
    const base64Value = base64String.split(",")[1];

    // Create the new item object, initially with assetId set to 0
    const newItem = {
      temporaryImagePath: base64String,
      imageData: base64Value,
      documentPath: "",
      fileType: file.type.split("/")[1],
      referenceId: 0,
      referenceType: "EMPLOYEE",
      documentType: type,
      createdAt: 0,
      assetId: 0, // New items will start with assetId = 0
    };

    // Find the index of an existing item with the same documentType
    const existingIndex = this.imageList.findIndex(
      (img) => img.documentType === type
    );

    if (existingIndex !== -1) {
      // If an existing item with the same documentType is found, update it
      this.imageList[existingIndex] = {
        ...this.imageList[existingIndex],
        temporaryImagePath: newItem.temporaryImagePath,
        imageData: newItem.imageData,
        documentPath: newItem.documentPath,
        fileType: newItem.fileType,
        assetId: this.imageList[existingIndex].assetId,
      };
    } else {
      // If no existing item with the same documentType, push the new item
      this.imageList.push(newItem);
    }

    // Update the form control or wherever the imageList is bound to
    this.Newjoin.controls["assetDetails"].setValue(this.imageList);
  }

  // Get image by type for preview
  getImageByType(type: string) {
    return this.imageList.find((item) => item.documentType === type) || null;
  }

  // Remove image by type
  removeImage(type: string) {
    const item = this.imageList.find((img) => img.documentType === type);

    if (item) {
      if (item.assetId && item.assetId !== 0) {
        // Call backend delete by assetId
        this.appService
          .deleteAsset(item.assetId)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            () => {
              this.imageList = this.imageList.filter(
                (img) => img.documentType !== type
              );
              this.toaster.success("File removed successfully");
            },
            () => {
              this.toaster.error("Failed to remove file from server");
            }
          );
      } else {
        // Not yet saved in DB, just remove locally
        this.imageList = this.imageList.filter(
          (img) => img.documentType !== type
        );
      }
    }
  }

  getByIdBasedNewJoiningDetails(id: number) {
    this.spinner.show();
    this.appService
      .getByIdNewJoiningDetails(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.currentNewJoinDetails = data;
          this.Newjoin.patchValue(this.currentNewJoinDetails);
          this.onSelectDesignation(this.currentNewJoinDetails?.designation);
          this.imageList = this.currentNewJoinDetails.assetDetails;

          this.imageList.forEach((item) => {
            if (item.assetId && !item.temporaryImagePath) {
              this.appService
                .fileGet(item.assetId)
                .pipe(takeUntil(this.destroy$))
                .subscribe(
                  (url: string) => {
                    // ✅ Expect string, not Blob
                    item.temporaryImagePath = url;
                  },
                  () => {
                    this.toaster.error("Failed to load file");
                  }
                );
            }
          });

          this.bankDisable = true;
          if (this.Newjoin.get("workingStatus").value != "WORKING") {
            this.onShowRelivingDate = true;
          } else {
            this.onShowRelivingDate = false;
          }
          this.isUpdate = true;
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error(
            error.error.message ||
              "Something went wrong, please try again later"
          );
        }
      );
  }

  updateNewJoining() {
    console.log("test", this.Newjoin.value);
    this.spinner.show();
    this.Newjoin.controls["workingStatus"].setValue(
      this.employeeStatusList.find(
        (e) => e.label === this.Newjoin.get("workingStatus").value
      )?.value
    );
    this.appService
      .updateNewJoiningDetails(this.Newjoin.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.updatedFileUploadDetails();
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error(
            error.error.message ||
              "Something went wrong, please try again later"
          );
        }
      );
  }

  updatedFileUploadDetails() {
    const payload = this.imageList.map((item) => ({
      assetId: item.assetId, // >0 if existing, 0 if new
      referenceId: this.formId,
      referenceType: "EMPLOYEE",
      documentType: item.documentType,
      fileType: item.fileType,
      imageData: item.imageData || null,
      documentPath: item.documentPath, // send base64 for new or updated image
    }));

    this.appService
      .fileUpload(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.toaster.success("Employee Details Updated Successfully");

          // Update local imageList with returned assetIds from server if needed
          data.forEach((resItem: any) => {
            const localItem = this.imageList.find(
              (i) => i.documentType === resItem.documentType
            );
            if (localItem) {
              localItem.assetId = resItem.assetId; // assign updated assetId from server
            }
          });

          this.router.navigate(["/main/new-joining-report"]);
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error(
            error.message || "Something went wrong, please try again..."
          );
        }
      );
  }

  updateNewSalaryDetails() {
    this.spinner.show();
    const jsonData = {
      formId: this.formId,
      salaryValueFixed: this.Newjoin.get("salaryValueFixed").value,
    };
    this.appService
      .updateNewJoiningSalaryDetails(jsonData)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.toaster.success("Salary Details Updated Successfully");
          this.router.navigate(["/ReportScreen"]);
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error(
            error.error.message ||
              "Something went wrong, please try again later"
          );
        }
      );
  }

  SuccessAlert() {
    Swal.fire({
      title: "Your Registration Saved Successfully",
      icon: "success",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Next",
      showClass: {
        popup: "animate_animated animate_fadeInDown",
      },
      hideClass: {
        popup: "animate_animated animate_fadeOutUp",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(["/main/new-joining-report"]);
      }
    });
  }

  errorAlert() {
    Swal.fire({
      title: "Sorry, Please Try Again Your Registration Process",
      icon: "error",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
      showClass: {
        popup: "animate_animated animate_fadeInDown",
      },
      hideClass: {
        popup: "animate_animated animate_fadeOutUp",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // window.location.reload();
      }
    });
  }

  ngOnDestroy(): void {
    localStorage.removeItem("formId");
  }
}
